import React from 'react';
import PropTypes from 'prop-types';
import {
  RadioGroupField,
  RadioGroupItem
} from '@ps-design-system/components/RadioGroup';
import { Text } from '@ps-design-system/components/Text';
import { useCheckoutContext } from '../../CheckoutContextProvider';
import { getMethodMetaById } from '../../checkout-utils';
import { useStripeElementsContext } from '../../StripeElementsContextProvider';

export const PaymentMethodField = ({ disabled, intl }) => {
  const { paymentForm } = useCheckoutContext();

  const { availablePaymentMethods, stripeElements } = useStripeElementsContext();

  const renderPaymentMethodOption = (paymentMethodOption) => {
      const meta = getMethodMetaById(paymentMethodOption, intl);

      if (!meta) {
        return null;
      }

      const { image, Icon, label } = meta;

      const renderProps = {
        label: <div className="tw-flex tw-justify-start tw-gap-8">
          <div style={{ width: 46 }}>
            {image
              ? <img style={{ height: 24, opacity: disabled ? 0.5 : 1 }} src={image} alt={label} />
              : Icon
                ? <Icon />
                : null
            }
          </div>
          <Text typeface="body-2-m">{label}</Text>
        </div>
      }

      return <RadioGroupItem
        value={paymentMethodOption}
        disabled={disabled}
        key={paymentMethodOption}
        id={paymentMethodOption}
        allowEventBubbling
        {...renderProps}
      />;
  }

  if (!stripeElements) {
    return null;
  }

  return (
    <div className="payment-form__payment-method-radio-group">
      <RadioGroupField
        formControl={paymentForm.control}
        name="selectedPaymentMethod"
        testId="payment-method-field"
        disabled={disabled}
        variant="box"
      >
        {availablePaymentMethods?.map(renderPaymentMethodOption)}
      </RadioGroupField>
    </div>
  );
};

PaymentMethodField.displayName = 'PaymentOptionField';
PaymentMethodField.propTypes = {
  disabled: PropTypes.bool
};
